import { useQuery } from '@tanstack/react-query';

import type { Data } from '@strapi/types';
import { getProjectDocumentAccesses } from '@/modules/shared-document/api/shared-documents.api';

export const useDocumentAccessesInit = ({
	projectDocumentId,
}: {
	projectDocumentId: Pick<Data.Entity<'api::project-document.project-document'>, 'documentId'>['documentId'];
}) => {
	const {
		data: documentAccesses,
		error,
		isLoading,
	} = useQuery({
		queryKey: ['GET_PROJECT_DOCUMENT_ACCESSES', projectDocumentId],
		queryFn: () => getProjectDocumentAccesses({ projectDocumentId }),
		enabled: !!projectDocumentId,
		refetchOnWindowFocus: true,
	});

	return {
		documentAccesses,
		error,
		isLoading,
	};
};
